import dayjs from "dayjs";
import dayjsBusinessDays from "dayjs-business-days";

dayjs.extend(dayjsBusinessDays);

/**
 * Get all trading days (business days) from today until expiration
 * @param {dayjs.Dayjs} expirationDate - Option expiration date
 * @param {dayjs.Dayjs} customDate - Custom "today" date (optional)
 * @returns {dayjs.Dayjs[]} - Array of trading days
 */
export function getTradingDaysUntilExpiration(expirationDate, customDate = null) {
  const today = customDate || dayjs();
  const tradingDays = [];

  let currentDay = today;

  // Loop through all days until expiration
  while (currentDay.isBefore(expirationDate) || currentDay.isSame(expirationDate, 'day')) {
    // Check if it's a business day (Monday-Friday, excluding holidays)
    if (currentDay.isBusinessDay()) {
      tradingDays.push(currentDay);
    }
    currentDay = currentDay.add(1, "day");
  }

  return tradingDays;
}

/**
 * Calculate number of trading days between two dates
 * @param {dayjs.Dayjs} startDate - Start date
 * @param {dayjs.Dayjs} endDate - End date
 * @returns {number} - Number of trading days
 */
export function countTradingDays(startDate, endDate) {
  return getTradingDaysUntilExpiration(endDate).filter((day) =>
    day.isSameOrAfter(startDate, "day")
  ).length;
}

/**
 * Calculate days to expiration (calendar days)
 * @param {dayjs.Dayjs} tradingDay - Current trading day
 * @param {dayjs.Dayjs} expirationDate - Expiration date
 * @returns {number} - Calendar days to expiration
 */
export function getDaysToExpiration(tradingDay, expirationDate) {
  return expirationDate.diff(tradingDay, "day");
}

/**
 * Calculate time to expiration in years (for Black-Scholes)
 * @param {number} daysToExpiration - Calendar days to expiration
 * @returns {number} - Time in years
 */
export function daysToYears(daysToExpiration) {
  return daysToExpiration / 365;
}
